export default {
  // Shown in Settings > Apps > Binnacle > Notifications as the system channel name.
  channelName: 'Binnacle alerts',
  channelDescription: 'Assigned tasks, completed audits and operational alerts',
  // TKT-2149: mock location alert in the notifications bell
  mock_user: 'User',
  mock_location: 'Location',
  mock_activity: 'Activity',
  mock_detected_at: 'Date and time',
  mock_result: 'Result'
}
